export const getNzDateTimeParts = (value: Date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'Pacific/Auckland',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(value);

  const pick = (type: string) => parts.find((p) => p.type === type)?.value || '';
  const date = `${pick('year')}-${pick('month')}-${pick('day')}`;
  const time = `${pick('hour')}:${pick('minute')}:${pick('second')}`;

  return { date, time };
};

export const getNzDateString = (value: Date = new Date()) => getNzDateTimeParts(value).date;

